import * as actionlist from '../actions/auditreportactions';
import moment from 'moment';
const state = {
    search: '',
    page: 0,
    startdate: moment().date(1).toDate(),
    enddate: moment().toDate(),
    user: [],
    action: null,
    startTime: { "HH": "00", "mm": "00" },
    endTime: { "HH": "23", "mm": "45" },
    client: [],
    attendant: []
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    startdate: state => state.startdate,
    enddate: state => state.enddate,
    user: state => state.user,
    action: state => state.action,
    startTime: state => state.startTime,
    endTime: state => state.endTime,
    client: state => state.client,
    attendant: state => state.attendant,
};

const actions = {
    [actionlist.AUDITREPORTLIST_SEARCH]: ({ commit }, search) => {
        commit(actionlist.AUDITREPORTLIST_SEARCH, search);
    },
    [actionlist.AUDITREPORTLIST_PAGE]: ({ commit }, page) => {
        commit(actionlist.AUDITREPORTLIST_PAGE, page);
    },
    [actionlist.AUDITREPORTLIST_STARTDATE]: ({ commit }, startdate) => {
        commit(actionlist.AUDITREPORTLIST_STARTDATE, startdate);
    },
    [actionlist.AUDITREPORTLIST_ENDDATE]: ({ commit }, enddate) => {
        commit(actionlist.AUDITREPORTLIST_ENDDATE, enddate);
    },
    [actionlist.AUDITREPORTLIST_USER]: ({ commit }, user) => {
        commit(actionlist.AUDITREPORTLIST_USER, user);
    },
    [actionlist.AUDITREPORTLIST_ACTION]: ({ commit }, action) => {
        commit(actionlist.AUDITREPORTLIST_ACTION, action);
    },
    [actionlist.AUDITREPORTLIST_STARTTIME]: ({ commit }, startTime) => {
        commit(actionlist.AUDITREPORTLIST_STARTTIME, startTime);
    },
    [actionlist.AUDITREPORTLIST_ENDTIME]: ({ commit }, endTime) => {
        commit(actionlist.AUDITREPORTLIST_ENDTIME, endTime);
    },
    [actionlist.AUDITREPORTLIST_CLIENT]: ({ commit }, client) => {
        commit(actionlist.AUDITREPORTLIST_CLIENT, client);
    },
    [actionlist.AUDITREPORTLIST_ATTENDANT]: ({ commit }, attendant) => {
        commit(actionlist.AUDITREPORTLIST_ATTENDANT, attendant);
    },
};

const mutations = {
    [actionlist.AUDITREPORTLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionlist.AUDITREPORTLIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionlist.AUDITREPORTLIST_STARTDATE]: (state, startdate) => {
        state.page = 0;
        state.startdate = startdate;
    },
    [actionlist.AUDITREPORTLIST_ENDDATE]: (state, enddate) => {
        state.page = 0;
        state.enddate = enddate;
    },
    [actionlist.AUDITREPORTLIST_USER]: (state, user) => {
        state.page = 0;        
        if (user.selected) {
            state.user.push(user.id);
        }
        else
            state.user = state.user.filter(x => x != user.id);
    },
    [actionlist.AUDITREPORTLIST_ACTION]: (state, action) => {
        state.page = 0;
        state.action = action;
    },
    [actionlist.AUDITREPORTLIST_STARTTIME]: (state, startTime) => {
        state.page = 0;
        state.startTime = startTime;
    },
    [actionlist.AUDITREPORTLIST_ENDTIME]: (state, endTime) => {
        state.page = 0;
        state.endTime = endTime;
    },
    [actionlist.AUDITREPORTLIST_CLIENT]: (state, client) => {
        state.page = 0;
        if (client.selected) {
            state.client.push(client.id);
        }
        else
            state.client = state.client.filter(x => x != client.id);
    },
    [actionlist.AUDITREPORTLIST_ATTENDANT]: (state, attendant) => {
        state.page = 0;
        if (attendant.selected) {
            state.attendant.push(attendant.id);
        }
        else
            state.attendant = state.attendant.filter(x => x != attendant.id);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
